/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionType from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';

const initialState = {
  dropdown: [],
  manufacturerList: [],
  errorMessagesInRedux: [],
  disputeCorrespondenceDetails: [],
  detailErrorMessages: [],
  disputeNdcAllDetails: [],
  disputeCodes: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_COMMON_DROPDOWN_DATA_CI:
      return {
        ...state,
        dropdown: action.dropdown,
      };
    case actionType.GET_MANUFACTURER_GRID_LIST:
      return {
        ...state,
        manufacturerList: action.manufacturerList,
      };
    case actionType.SELECTION_TYPE_OPTIONS:
      return { ...state, selection_list: action.payload };
    case actionType.DROPDOWN_UPDATED_LIST:
      return { ...state, dropdownUpdatedList: action.payload };
    case actionType.STATUS_SELECTED_TYPE:
      return { ...state, statusSelectedType: action.payload };
    case actionType.ASSIGNED_USERS_LIST:
      return { ...state, assignedToUsers: action.payload };
    case actionType.SINGLE_HEADER_DETAILS:
      return { ...state, singleHeaderDetails: action.payload };
    case actionType.DISPUTE_HEADER_DETAILS:
      return { ...state, disputeManufacturerHeaderDetails: action.payload };
    case actionType.DISPUTE_BODY_DETAILS:
      return { ...state, disputeManufacturerBodyDetails: action.payload };
    case actionType.DISPUTE_DETAILS_CORRESPONDENCE:
      return { ...state, disputeCorrespondenceDetails: action.payload };
    case actionType.DISPUTE_NDC_DETAILS:
      return { ...state, disputeNdcAllDetails: action.payload };
    case actionType.SINGLE_DISPUTE_NDC_DETAILS:
      return { ...state, singleDisputeNdc: action.payload };
    case actionType.HANDLE_ERROR_MESSAGE:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionType.DETAIL_ERROR_MESSAGE:
      return { ...state, detailErrorMessages: action.payload };
    case actionType.NDC_DETAIL_ERROR_MESSAGE:
      return { ...state, ndcDetailErrorMessages: action.payload };
    case actionType.GET_DISPUTE_CODES:
      return { ...state, disputeCodes: action.payload };
      
    case actionType.RESET_DISPUTES_DATA:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
